export default __webpack_public_path__ + "static/media/spaces_in_doha_256.57165c26.jpg";